<template>
  <div class="container py-5">
    <p>
    <b>TSK誠摯邀請您參加2025台灣醫用雷射光電學會！</b>
    <br>一同探索最新醫美市場趨勢，感受來自日本的尖端技術與匠心品質，開啟專業交流與創新啟發，期待您的蒞臨！
    <br><br><b>🎯展會亮點</b><br>🌟 專業技術交流｜探索最新應用與市場趨勢<br>🌟 現場產品體驗｜親身感受TSK尖針與鈍針的匠心工藝<br>🌟 獨家優惠活動｜參展醫師專屬優惠活動<br><br><b>📍展會資訊</b><br>展會時間：2025/3/30(日)<br> 展會地點：華南銀行國際會議中心<br> 攤位編號：18
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_54.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
